<div class="modal-header">
  <div class="modal-title">{{ step.nr }} - {{ step.text }} abmelden</div>
</div>

<form [formGroup]="form" (ngSubmit)="submit()" class="form form-horizontal">
  <div class="modal-body">
    @if (!step.use_good_pieces) {
      <div class="form-group">
        <label for="id_wastrel" class="col-sm-3 control-label">Ausschuss (Menge)</label>
        <div class="col-sm-9">
          <input type="number" id="id_wastrel" class="form-control" formControlName="wastrel"
            [ngClass]="{red_alert: errors['wastrel']}">
        </div>
      </div>
    }

    @if (!!step.use_good_pieces) {
      <div class="form-group">
        <label for="id_good_pieces" class="col-sm-3 control-label">
          <div class="label label-primary">Gutstück (Menge)</div>
        </label>
        <div class="col-sm-9">
          <input type="number" id="id_good_pieces" class="form-control" formControlName="good_pieces"
            [ngClass]="{red_alert: errors['good_pieces']}">
        </div>
      </div>
    }

    @if (this.lastGoodUtilize !== null) {
      <div class="form-group">
        <label for="id_good_utilize" class="col-sm-3 control-label">Nutzenanzahl</label>
        <div class="col-sm-9">
          <input id="id_good_utilize"
            type="number"
            class="form-control"
            formControlName="good_utilize"
            [ngClass]="{red_alert: errors['good_utilize']}">
        </div>
      </div>
    }

    @if ((form.value.wastrel > 0) && (reasons.active)) {
      <div class="form-group">
        <label for="id_wastrel_reason_id" class="col-sm-3 control-label">Ausschussgrund</label>
        <div class="col-sm-9">
          <select id="id_wastrel_reason_id"
            class="form-control"
            formControlName="wastrel_reason_id"
            [ngClass]="{red_alert: errors['wastrel_reason_id']}">
            <option [ngValue]="null">
              -
            </option>
            @for (reason of (reasons?.objects ?? []); track reason) {
              <option [ngValue]="reason.id">
                {{ reason.reason }}
              </option>
            }
          </select>
        </div>
      </div>
    }

    @for (questionnaireForm of questionnaireForms; track trackByIndexFn(i, questionnaireForm); let i = $index) {
      <ng-container formArrayName="questionnaire_forms">
        <div class="form-group" [formGroup]="questionnaireForm.form">
          <label [for]="'form_value_' + i" class="col-sm-3 control-label">{{questionnaireForm.questionnaire.name}}</label>
          <div class="col-sm-7">
            @switch (questionnaireForm.questionnaire.data_type) {
              @case (0) {
                <input [id]="'form_value_' + i" type="text" class="form-control" formControlName="questionnaire_value">
              }
              @case (2) {
                <input [id]="'form_value_' + i" type="number" step="0.001" class="form-control align-right" formControlName="questionnaire_value">
              }
              @case (3) {
                <input [id]="'form_value_' + i" type="number" step="0.001" min="0.001" class="form-control align-right" formControlName="questionnaire_value">
              }
              @case (4) {
                <input [id]="'form_value_' + i" type="number" class="form-control align-right" formControlName="questionnaire_value">
              }
              @case (5) {
                <input [id]="'form_value_' + i" type="number" min="0" class="form-control align-right" formControlName="questionnaire_value">
              }
              @case (128) {
                <input [id]="'form_value_' + i" type="checkbox" class="form-control align-right" formControlName="questionnaire_value">
              }
            }
          </div>
          @if (!!questionnaireForm.questionnaire.unit) {
            <div class="col-sm-2 control-label">
              {{questionnaireForm.questionnaire.unit}}
            </div>
          }
        </div>
      </ng-container>
    }

    <div class="form-group">
      <label for="id_comment" class="col-sm-3 control-label">
        Kommentar @if (commentIsRequired) {
        <span>(Pflicht)</span>
      }
    </label>

    <div class="col-sm-9">
      <textarea id="id_comment" class="form-control" formControlName="comment"
        [ngClass]="{red_alert: errors['comment']}">
      </textarea>
    </div>
  </div>

  @if (!step.use_good_pieces && underDelivery && form.value.wastrel > 0) {
    <div class="form-group">
      <div class="col-sm-8">
        <div class="control-label">
          Achtung! Lieferuntergrenze wird unterschritten!
        </div>
      </div>
      <div class="col-sm-4 text-right">
        <label for="force" class="control-label inline-block">
          Trotzdem abmelden
        </label>&nbsp;
        <input id="force"
          type="checkbox"
          class="form-control inline-block"
          style="width: 16px; height: 16px;"
          formControlName="force">
      </div>
    </div>
  }

  @if (errorMessages.length > 0) {
    <div class="alert alert-danger">
      @for (message of errorMessages; track message) {
        <div>
          @switch (message) {
            @case ('illegal_good_pieces') {
              Die Anzahl an Gutstücken darf nicht negativ oder leer sein
            }
            @case ('illegal_good_utilize') {
              Die Anzahl an Nutzen darf nicht negativ oder leer sein
            }
            @case ('illegal_wastrel') {
              Bitte Ausschuss angeben
            }
            @case ('wastrel_and_good_pieces_null') {
              @if (!step.use_good_pieces) {
                Bitte Ausschuss angeben
              }
              @if (step.use_good_pieces) {
                Die Anzahl an Gutstücken darf nicht negativ oder leer sein
              }
            }
            @case ('wastrel_too_high') {
              Ausschuss zu hoch. Keine Abmeldung möglich
            }
            @case ('wastrel_reason_required') {
              Bitte Ausschussgrund angeben
            }
            @case ('comment_needed') {
              Bitte Kommentar eingeben
            }
            @case ('under_delivery') {
              Lieferuntergrenze wird untertschritten
            }
          }
        </div>
      }
    </div>
  }
</div>

<div class="modal-footer">
  <button type="submit" class="btn btn-success btn-sm pull-right" [disabled]="locked">
    Fertigungsschritt abmelden
  </button>
</div>
</form>
